import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {  MatDialog } from '@angular/material/dialog';
import { UnsavedChangesWarningDialogComponent, UnsavedChangesWarningDialogResponse } from './unsaved-changes-warning-dialog.component';

@Injectable()
export class FormChangeStateService {
  private saveForm: Subject<symbol> = new Subject<symbol>();

  private readonly formChangedSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private readonly formChangedWithoutFileSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private readonly isFormValidSubject: BehaviorSubject<boolean> = new BehaviorSubject(true);
  private readonly isFormInvalid: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private readonly matDialog: MatDialog) {
  }

  setFormChanged(changed: boolean): void {
    this.formChangedSubject.next(changed);
  }

  setFormChangedWithoutFile(changed: boolean): void {
    this.formChangedWithoutFileSubject.next(changed);
  }

  isFormChanged(): boolean {
    return this.formChangedSubject.getValue();
  }

  isFormChangedObservable(): Observable<boolean> {
    return this.formChangedSubject.asObservable();
  }

  isFormChangedWithoutFile(): boolean {
    return this.formChangedWithoutFileSubject.getValue();
  }

  /**
   * @Deprecated use {@link updateFormValidity} instead
   *
   * @param formValid
   */
  setFormValidity(formValid: boolean): void {
    this.isFormInvalid.next(formValid);
  }

  updateFormValidity(isFormValid: boolean): void {
    this.isFormValidSubject.next(isFormValid);
  }

  /**
   * @Deprecated use {@link isFormValidState} instead
   */
  isFormValid(): Observable<boolean> {
    return this.isFormInvalid.asObservable();
  }

  isFormValidState(): Observable<boolean> {
    return this.isFormValidSubject.asObservable();
  }

  setSaveForm(): void {
    this.saveForm.next(Symbol(''));
  }

  getSaveForm(): Observable<symbol> {
    return this.saveForm.asObservable();
  }

  showWarning(): Observable<UnsavedChangesWarningDialogResponse> {
    return this.matDialog.open(UnsavedChangesWarningDialogComponent, {
      panelClass: 'modal-sm',
      data: {
        isValid$: this.isFormValid(),
      }
    }).afterClosed();
  }
}
